var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaylists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3c-.558 0-1 .442-1 1h11a1 1 0 0 0-1-1H7zM4 4c0 .056.005.111.013.165A2.993 2.993 0 0 0 2 7c0 .056.005.111.013.165A2.993 2.993 0 0 0 0 10v10a3 3 0 0 0 3 3h18c1.652 0 3-1.348 3-3V10a3 3 0 0 0-3-3 3 3 0 0 0-2.014-2.834A1.01 1.01 0 0 0 19 4a3 3 0 0 0-3-3H7C5.338 1 4 2.338 4 4zm0 3c0-.558.442-1 1-1h13a1 1 0 0 1 1 1H4zm-2 3c0-.558.442-1 1-1h18a1 1 0 0 1 1 1v10c0 .548-.452 1-1 1H3a1 1 0 0 1-1-1V10zm9.897.352C10.736 9.507 9 10.274 9 11.8v6.4c0 1.526 1.736 2.293 2.897 1.448l.003-.002 4.361-3.198.001-.001a1.787 1.787 0 0 0 0-2.894L11.9 10.354l-.003-.002zM14.853 15 11 12.175v5.65L14.853 15z",
    fill: "#ACAEC5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylists);
export default __webpack_public_path__ + "static/media/playlists.f0610de2cf69cbf1ea86424d8fe9bfac.svg";
export { ForwardRef as ReactComponent };